import React, { useMemo } from "react";

import "./styles.scss";

export default function SigmaMatchPanel({ match }) {
  const tactics = useMemo(
    () =>
      Array.isArray(match?.mitre) ? match.mitre.map((s) => String(s).trim()).filter(Boolean) : [],
    [match],
  );

  const score = Number.isFinite(Number(match?.rule_score)) ? Number(match.rule_score) : undefined;
  const sevText = (match?.severity || "").toString();
  const level = Number.isFinite(Number(match?.level)) ? Number(match.level) : undefined;
  const ruleId = match?.rule_key || match?.id;

  return (
    <div className="thunter-additional-data__sigma-panel">
      <div>
        <div className="thunter-additional-data__sigma-panel__summary thunter-additional-data__sigma-panel__summary--soft">
          <div className="thunter-additional-data__sigma-panel__lead">
            <Field label="Rule Name" value={match?.rule_name} strong />
          </div>
          {typeof score !== "undefined" && sevText && (
            <span
              className={`thunter-additional-data__sigma-panel__score ${
                sevText === "critical" || sevText === "high"
                  ? "thunter-additional-data__sigma-panel__score--high"
                  : sevText === "medium"
                  ? "thunter-additional-data__sigma-panel__score--med"
                  : "thunter-additional-data__sigma-panel__score--low"
              }`}>
              Score: {score}
            </span>
          )}
        </div>

        <div className="thunter-additional-data__sigma-panel__row thunter-additional-data__sigma-panel__row--spread">
          {sevText && <Field label="Severity" value={sevText.toUpperCase()} />}
          {typeof level !== "undefined" && <Field label="Level" value={level} />}
          {match?.source && <Field label="Engine" value={String(match.source).toUpperCase()} />}
          {!!tactics.length && <Field label="MITRE" value={tactics.join(" • ")} />}
        </div>
      </div>

      {match?.rule_description && (
        <div className="thunter-additional-data__sigma-panel__section thunter-additional-data__sigma-panel__section--flush">
          <div className="thunter-additional-data__sigma-panel__section-title">Description</div>
          <p className="thunter-additional-data__sigma-panel__section-text">
            {match.rule_description}
          </p>
        </div>
      )}

      {match?.selector && (
        <div className="thunter-additional-data__sigma-panel__section thunter-additional-data__sigma-panel__section--flush">
          <div className="thunter-additional-data__sigma-panel__section-title">
            Selector (SQL)
            <div className="thunter-additional-data__sigma-panel__actions">
              <button
                className="thunter-additional-data__sigma-panel__btn"
                onClick={() => copyToClipboard(match.selector)}
                title="Copy SQL">
                Copy
              </button>
            </div>
          </div>
          <pre className="thunter-additional-data__sigma-panel__code" title="Sigma selector SQL">
            {match.selector}
          </pre>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, mono = false, strong = false, copyable = false }) {
  if (value == null || value === "") return null;
  return (
    <div className="thunter-additional-data__sigma-panel__field" title={String(value)}>
      <div className="thunter-additional-data__sigma-panel__field-k">{label}:</div>
      <div
        className={[
          "thunter-additional-data__sigma-panel__field-v",
          mono ? "thunter-additional-data__sigma-panel__field-v--mono" : "",
          strong ? "thunter-additional-data__sigma-panel__field-v--strong" : "",
        ]
          .join(" ")
          .trim()}>
        {String(value)}
      </div>
      {copyable && (
        <button
          className="thunter-additional-data__sigma-panel__copy"
          onClick={() => copyToClipboard(String(value))}
          title="Copy value">
          <CopyIcon />
        </button>
      )}
    </div>
  );
}

function CopyIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <rect x="4" y="4" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function copyToClipboard(text) {
  if (!text) return;
  try {
    navigator.clipboard?.writeText?.(String(text));
  } catch (e) {
    console.error("Failed to copy:", e);
  }
}
